export const O_CLIENT_APP = "OLIVEEB_ADMIN_PORTAL_WEB_UI";
export const AUTHORIZATION_HEADER_KEY = "Authorization";
export const ACTOR_ID_HEADER_KEY = "O-ACTOR-ID";
export const CLIENT_NAME_HEADER_KEY = "O-CLIENT-NAME";
export const CLIENT_NAME_HEADER_VALUE = "oliveeb-admin-portal-web-ui";
export const O_API_KEY = "fe4c97e9-1733-4f13-8ac9-c6e56ea0a98a";

const API_PROTOCOL = process.env.REACT_APP_API_PROTOCOL || "https";

// Require REACT_APP_ENV to be explicitly set; fail if missing
const ENV = process.env.REACT_APP_ENV;
if (!ENV) {
  throw new Error(
    "REACT_APP_ENV environment variable is required. " +
      "Set it via .env.local (e.g., REACT_APP_ENV=dev) or Cloud Build substitution _ENV."
  );
}

const HOST_MAP = {
  prod: "api.oliveeb.com",
  production: "api.oliveeb.com",
  uat: "uat.oliveeb.com",
  staging: "uat.oliveeb.com",
  dev: "dev.oliveeb.com",
  development: "dev.oliveeb.com",
};

const DEFAULT_HOST = HOST_MAP[ENV] || HOST_MAP.dev;
export const API_HOST = process.env.REACT_APP_API_HOST || DEFAULT_HOST;
export const API_BASE_URL = `${API_PROTOCOL}://${API_HOST}`;

export const CORE_API_BASE_URL = `${API_BASE_URL}/api/v1`;
export const IDENTITY_SERVICE_BASE_URL = `${API_BASE_URL}/identity-service`;
export const OLITASK_SERVICE_BASE_URL = `${API_BASE_URL}/olitask-service`;
export const PAYMENT_SERVICE_BASE_URL = `${API_BASE_URL}/payment-service`;
export const PROFILE_SERVICE_BASE_URL = `${API_BASE_URL}/profile-service`;
export const OLREADIA_SERVICE_BASE_URL = `${API_BASE_URL}/olreadia-service`;
export const STORAGE_BASE_URL = `${API_BASE_URL}/storage-service`;
export const COMMUNICATION_SERVICE_BASE_URL = `${API_BASE_URL}/communication-service`;
export const NOTIFICATION_SERVICE_BASE_URL = `${API_BASE_URL}/notification-service`;
export const EMAIL_SERVICE_BASE_URL = `${API_BASE_URL}/email-service`;
export const COMPOSER_SERVICE_BASE_URL = `${API_BASE_URL}/composer-service`;
export const OVIZIA_SERVICE_BASE_URL = `${API_BASE_URL}/ovizia-service`;

// Mirrors `com.oliveeb.gateway.model.OliveebApp` (gateway-service).
// Backend serializes these enums as the lowercase, hyphenated strings via `@JsonValue`.
const FRONTEND_APP_OPTIONS = [
  { value: "olitask-mobile-ui", label: "olitask-mobile-ui" },
  { value: "olitask-web-ui", label: "olitask-web-ui" },
  { value: "oliveeb-admin-portal-web-ui", label: "oliveeb-admin-portal-web-ui" },
  { value: "olreadia-web-ui", label: "olreadia-web-ui" },
  { value: "olreadia-mobile-ui", label: "olreadia-mobile-ui" },
  { value: "care-web-ui", label: "care-web-ui" },
  { value: "ovacus-web-ui", label: "ovacus-web-ui" },
  { value: "ovacus-mobile-ui", label: "ovacus-mobile-ui" },
  { value: "oddwize-web-ui", label: "oddwize-web-ui" },
  { value: "oddwize-mobile-ui", label: "oddwize-mobile-ui" },
  { value: "ovizia-web-ui", label: "ovizia-web-ui" },
  { value: "ovizia-mobile-ui", label: "ovizia-mobile-ui" },
  { value: "auto-web-ui", label: "auto-web-ui" },
  { value: "auto-mobile-ui", label: "auto-mobile-ui" },
  { value: "oliveeb-postman-internal", label: "oliveeb-postman-internal" },
];

const BACKEND_APP_OPTIONS = [
  { value: "olitask-main-service", label: "olitask-main-service" },
  { value: "oliveeb-gateway-service", label: "oliveeb-gateway-service" },
  { value: "oliveeb-identity-service", label: "oliveeb-identity-service" },
  { value: "oliveeb-profile-service", label: "oliveeb-profile-service" },
  { value: "oliveeb-payment-service", label: "oliveeb-payment-service" },
  { value: "oliveeb-storage-service", label: "oliveeb-storage-service" },
  { value: "oliveeb-notification-service", label: "oliveeb-notification-service" },
  { value: "oliveeb-chat-service", label: "oliveeb-chat-service" },
  { value: "oliveeb-communication-service", label: "oliveeb-communication-service" },
  { value: "oliveeb-email-service", label: "oliveeb-email-service" },
  { value: "oliveeb-code-service", label: "oliveeb-code-service" },
  { value: "oliveeb-cache-service", label: "oliveeb-cache-service" },
  { value: "oliveeb-social-service", label: "oliveeb-social-service" },
  { value: "oliveeb-pm-service", label: "oliveeb-pm-service" },
  { value: "oliveeb-ai-service", label: "oliveeb-ai-service" },
  { value: "oliveeb-olreadia-service", label: "oliveeb-olreadia-service" },
  { value: "oliveeb-care-service", label: "oliveeb-care-service" },
  { value: "oliveeb-ovizia-service", label: "oliveeb-ovizia-service" },
  { value: "oliveeb-ovacus-service", label: "oliveeb-ovacus-service" },
  { value: "oliveeb-oddwize-service", label: "oliveeb-oddwize-service" },
  { value: "anonymous-service", label: "anonymous-service" },
];

export const OLIVEEB_APP_OPTIONS = [
  ...new Map(
    [...FRONTEND_APP_OPTIONS, ...BACKEND_APP_OPTIONS].map((item) => [item.label, item])
  ).values(),
];

export const OLIVEEB_APP_VALUES = [...new Set(OLIVEEB_APP_OPTIONS.map((option) => option.value))];

export const CLIENT_APP_OPTIONS = [
  { value: "olitask-mobile-ui", label: "olitask-mobile-ui" },
  { value: "olitask-web-ui", label: "olitask-web-ui" },
  { value: "oliveeb-admin-portal-web-ui", label: "oliveeb-admin-portal-web-ui" },
  { value: "olreadia-web-ui", label: "olreadia-web-ui" },
  { value: "olreadia-mobile-ui", label: "olreadia-mobile-ui" },
  { value: "care-web-ui", label: "care-web-ui" },
  { value: "ovacus-web-ui", label: "ovacus-web-ui" },
  { value: "ovacus-mobile-ui", label: "ovacus-mobile-ui" },
  { value: "oddwize-web-ui", label: "oddwize-web-ui" },
  { value: "oddwize-mobile-ui", label: "oddwize-mobile-ui" },
  { value: "ovizia-web-ui", label: "ovizia-web-ui" },
  { value: "ovizia-mobile-ui", label: "ovizia-mobile-ui" },
  { value: "auto-web-ui", label: "auto-web-ui" },
  { value: "auto-mobile-ui", label: "auto-mobile-ui" },
];

export const OLIVEEB_BACKEND_SERVICE_VALUES = [
  "OLIVEEB_PAYMENT_SERVICE",
  "OLIVEEB_OLREADIA_SERVICE",
  "OLIVEEB_OVACUS_SERVICE",
  "OLIVEEB_OVIZIA_SERVICE",
  "OLIVEEB_OLITASK_SERVICE",
  "OLIVEEB_ODDWIZE_SERVICE",
  "OLIVEEB_CARE_SERVICE",
];

export const OLIVEEB_BACKEND_SERVICE_LABELS = {
  OLIVEEB_PAYMENT_SERVICE: "All",
  OLIVEEB_OLREADIA_SERVICE: "Olreadia",
  OLIVEEB_OVACUS_SERVICE: "Ovacus",
  OLIVEEB_OVIZIA_SERVICE: "Ovizia",
  OLIVEEB_OLITASK_SERVICE: "Olitask",
  OLIVEEB_ODDWIZE_SERVICE: "Oddwize",
  OLIVEEB_CARE_SERVICE: "Care",
};

export const OLIVEEB_BACKEND_SERVICE_OPTIONS = OLIVEEB_BACKEND_SERVICE_VALUES.map((value) => ({
  value,
  label: OLIVEEB_BACKEND_SERVICE_LABELS[value] || value,
}));

export const RBAC_RESOURCE_TYPE_OPTIONS = [
  { value: "PRODUCT", label: "PRODUCT" },
  { value: "SYSTEM", label: "SYSTEM" },
];

export const APP_LINKS = {
  ios: "https://appstoreconnect.apple.com/teams/767e23a7-ecf5-4a22-815e-5525630bddd7/apps/6753580996/testflight/ios",
  android: "https://play.google.com/apps/internaltest/4701619456935802876",
};

export const SMART_APP_LINK = APP_LINKS.both;
